export function listingFormatFilterChipActiveClasses(formatId: string): string {
  switch (formatId) {
    case "fixed_price":
      return "border-transparent bg-neutral-900 text-white shadow-black/20 ring-1 ring-white/10 hover:!bg-neutral-800 dark:bg-white dark:text-neutral-900 dark:ring-0 dark:hover:!bg-neutral-100";
    case "fixed_price_with_offers":
      return "border-transparent bg-violet-500 text-white shadow-violet-900/30 ring-1 ring-violet-200/80 hover:!bg-violet-600 dark:ring-violet-300/50 dark:hover:!bg-violet-600";
    case "offers_only":
      return "border-transparent bg-emerald-700 text-white shadow-emerald-900/30 ring-1 ring-emerald-200/70 hover:!bg-emerald-600 dark:ring-emerald-300/45 dark:hover:!bg-emerald-600";
    case "auction":
      return "border-transparent bg-red-500 text-white shadow-red-900/30 ring-1 ring-red-200/80 hover:!bg-red-600 dark:ring-red-300/50 dark:hover:!bg-red-600";
    default:
      return "";
  }
}

export function listingFormatFilterChipInactiveClasses(formatId: string): string {
  switch (formatId) {
    case "fixed_price":
      return "border-neutral-300/90 bg-neutral-100/90 text-neutral-800 ring-1 ring-neutral-300/60 backdrop-blur-md hover:bg-neutral-200/80 dark:border-neutral-600 dark:bg-neutral-950/50 dark:text-neutral-100 dark:ring-neutral-600/55 dark:hover:bg-neutral-900/70";
    case "fixed_price_with_offers":
      return "border-violet-300/80 bg-violet-50/95 text-violet-900 ring-1 ring-violet-200/90 backdrop-blur-md hover:bg-violet-100/90 dark:border-violet-500/30 dark:bg-violet-950/45 dark:text-violet-200 dark:ring-violet-800/40 dark:hover:bg-violet-950/65";
    case "offers_only":
      return "border-emerald-300/80 bg-emerald-50/95 text-emerald-900 ring-1 ring-emerald-200/90 backdrop-blur-md hover:bg-emerald-100/90 dark:border-emerald-500/30 dark:bg-emerald-950/45 dark:text-emerald-200 dark:ring-emerald-800/40 dark:hover:bg-emerald-950/65";
    case "auction":
      return "border-red-300/80 bg-red-50/95 text-red-900 ring-1 ring-red-200/90 backdrop-blur-md hover:bg-red-100/90 dark:border-red-500/35 dark:bg-red-950/45 dark:text-red-200 dark:ring-red-800/40 dark:hover:bg-red-950/65";
    default:
      return "border-border/40 bg-background/35 text-foreground backdrop-blur-md hover:bg-muted/60 dark:border-white/12 dark:bg-white/5 dark:hover:bg-white/10";
  }
}

export function listingFormatFilterTriggerActiveClasses(selectedFormats: string[]): string {
  if (selectedFormats.length === 0) return "";
  if (selectedFormats.length > 1) {
    return "border-neutral-400/50 bg-neutral-900/10 text-neutral-900 dark:border-white/25 dark:bg-white/10 dark:text-white";
  }
  const id = selectedFormats[0];
  switch (id) {
    case "fixed_price":
      return "border-neutral-400/50 bg-neutral-900/10 text-neutral-900 dark:border-white/25 dark:bg-white/10 dark:text-white";
    case "fixed_price_with_offers":
      return "border-violet-500/40 bg-violet-500/12 text-violet-800 dark:border-violet-400/40 dark:bg-violet-500/15 dark:text-violet-200";
    case "offers_only":
      return "border-emerald-600/40 bg-emerald-700/12 text-emerald-900 dark:border-emerald-500/40 dark:bg-emerald-700/15 dark:text-emerald-200";
    case "auction":
      return "border-red-500/45 bg-red-500/12 text-red-800 dark:border-red-400/40 dark:bg-red-500/15 dark:text-red-200";
    default:
      return "bg-primary/10 text-primary border-primary";
  }
}
